import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { LayoutState } from "../../../types/states/layout.state.type";
import type { PageTitle } from "../../../types/ux/pageTitle.ux.type";
import type { FrequentOption } from "../../../types/models/frequentOption.model.type";

const initialState: LayoutState = {
  openSidebar: true,
  pageTitle:
    localStorage.getItem("last-menu") !== null
      ? JSON.parse(localStorage.getItem("last-menu")!)
      : { title: "Principal", icon: "home" },
  frequentOptions: {
    isFetching: false,
    data: [],
    error: undefined,
  },
  messageFooter: undefined,
};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    onToggleVisibleSidebar: (state) => {
      state.openSidebar = !state.openSidebar;
    },
    onChangePageTitle: (state, { payload }: PayloadAction<PageTitle>) => {
      localStorage.setItem("last-menu", JSON.stringify(payload));
      state.pageTitle = payload;
    },

    rxStartFetchingFrequentOptions: (state) => {
      state.frequentOptions.isFetching = true;
      state.frequentOptions.error = undefined;
    },
    rxSuccessFetchingFrequentOptions: (state, { payload }: PayloadAction<FrequentOption[]>) => {
      state.frequentOptions.isFetching = false;
      state.frequentOptions.data = payload;
      state.frequentOptions.error = undefined;
    },
    rxErrorFetchingFrequentOptions: (state, { payload }: PayloadAction<string>) => {
      state.frequentOptions.isFetching = false;
      state.frequentOptions.error = payload;
    },

    // Message Footer
    rxSetDefaultMessageFooter: (state, { payload }: PayloadAction<{ label: string }>) => {
      state.messageFooter = {
        message: payload.label,
        type: "DEFAULT",
      };
    },

    rxSetSuccessMessageFooter: (state, { payload }: PayloadAction<{ label: string; icon?: boolean | undefined }>) => {
      state.messageFooter = {
        message: payload.label,
        type: "SUCCESS",
        icon: payload.icon ? "circle-check" : undefined,
      };
    },

    rxSetWarningMessageFooter: (state, { payload }: PayloadAction<{ label: string; icon?: boolean | undefined }>) => {
      state.messageFooter = {
        message: payload.label,
        type: "WARNING",
        icon: payload.icon ? "circle-exclamation" : undefined,
      };
    },

    rxSetErrorMessageFooter: (state, { payload }: PayloadAction<{ label: string; icon?: boolean | undefined }>) => {
      state.messageFooter = {
        message: payload.label,
        type: "ERROR",
        icon: payload.icon ? "circle-xmark" : undefined,
      };
    },

    rxClearMessageFooter: (state) => {
      state.messageFooter = undefined;
    },
  },
});

export const layoutSelector = (state: { layout: LayoutState }) => state.layout;
export const {
  onToggleVisibleSidebar,
  onChangePageTitle,
  rxStartFetchingFrequentOptions,
  rxSuccessFetchingFrequentOptions,
  rxErrorFetchingFrequentOptions,
  rxSetDefaultMessageFooter,
  rxSetSuccessMessageFooter,
  rxSetWarningMessageFooter,
  rxSetErrorMessageFooter,
  rxClearMessageFooter,
} = layoutSlice.actions;
export default layoutSlice.reducer;
